import ContactsForm from '~/components/features/contacts/ContactsMain/ContactsBodyForm/ContactsForm';

import cn from './style.module.sass';
export default function ContactsBodyForm() {
    return (
        <>
            <h2 className={cn['contacts__form-title']}>Хотите заказать у нас проект?</h2>
            <div className={cn['contacts__form-subtitle']}>
                Оставьте заявку и расскажите, какие бизнес-задачи перед вами стоят, мы подготовим
                релевантные для вас кейсы и сразу перезвоним. А если не хотите ждать, наберите нас
                прямо сейчас по номеру
                <a className={cn['contacts__form-tel']} href="tel:84955405179">
                    {' '}
                    +7 495 540-51-79
                </a>
            </div>
            <ContactsForm />
        </>
    );
}
